module.exports = __webpack_public_path__ + "static/img/ap11.a3f2d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap11.jpg
// module id = C0xX
// module chunks = 1